import React from 'react';
import PropTypes from 'prop-types';
import { Heading, Text } from '@nerdwallet/react-typography';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import Image from '@nerdwallet/react-image';

const ReasonsToBelieve = ({ eyebrow, title, bullets, imageUrl }) => (
  <ElementImpression
    elementDomType="div"
    elementName="ReasonsToBelieve"
    id="reasons-to-believe"
  >
    <div className="reasons">
      <div className="reasons__content">
        <div className="reasons__copy">
          <Text color="neutral-darker" uppercase small bold>
            {eyebrow}
          </Text>
          <Heading level={2} chronicle className="reasons__heading">
            {title}
          </Heading>
          <div className="reasons__bullets">
            {bullets.map((bullet) => (
              <div className="reasons__bullet" key={bullet.title}>
                <Heading level="5">{bullet.title}</Heading>
                <Text>{bullet.content}</Text>
              </div>
            ))}
          </div>
        </div>
        {imageUrl ? (
          <div className="reasons__image">
            <Image
              src={imageUrl}
              alt=""
              naturalWidth={1206}
              naturalHeight={1344}
              backgroundColor="transparent"
              role="presentation"
            />
          </div>
        ) : null}
      </div>
    </div>
  </ElementImpression>
);

ReasonsToBelieve.propTypes = {
  bullets: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.string,
    })
  ),
  eyebrow: PropTypes.string,
  imageUrl: PropTypes.string,
  title: PropTypes.string,
};

ReasonsToBelieve.defaultProps = {
  eyebrow: 'You got this',
  title: 'Everything you need — totally free',
  bullets: [],
};

export default ReasonsToBelieve;
